import React from 'react';

import PropTypes from 'prop-types';
import { Notification, RadioGroup, Spacer } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../../../../context/LocalizedStringsContext';

const TankPortSize = ({ dataField, setDataField, error }) => {
  const {
    iotOrderDetailsSection: { tankPortSize },
    modalForm: { fieldRequiredMessage }
  } = useLocalizedStringsContext();

  const fieldOptions = [
    '1/4in NPT',
    '1/2in NPT',
    '1-1/2in NPT',
    '2in NPT',
    '3in NPT',
    'Other'
  ];
  const fieldHasError = error && !dataField.valueTankPortSize;
  const otherFieldHasError =
    error &&
    dataField.valueTankPortSize === 'Other' &&
    !dataField.valueTankPortSizeOther;

  const radioItems = fieldOptions.map(option => ({
    label: option,
    id: option
  }));

  return (
    <>
    <Spacer space={4} />
      <RadioGroup
        legend={tankPortSize}
        items={radioItems}
        checkedId={dataField.valueTankPortSize || null}
        onChange={(value) => setDataField({
          ...dataField,
          valueTankPortSize: value
        })}
        name="tank-port-size"
        validation={fieldHasError ? 'error' : undefined}
        feedback={fieldHasError ? fieldRequiredMessage : undefined}
      />
      {dataField.valueTankPortSize === 'Other' && (
        <input
          type="text"
          className={`tank-details__other-product ${otherFieldHasError &&
            'error'}`}
          placeholder="port size.."
          value={dataField.valueTankPortSizeOther}
          onChange={e =>
            setDataField({
              ...dataField,
              valueTankPortSizeOther: e.target.value
            })
          }
        />
      )}
      {otherFieldHasError && (
        <div style={{ marginTop: '5px' }}>
          <Notification variant={{ validation: 'error' }}>
            {fieldRequiredMessage}
          </Notification>
        </div>
      )}
      <Spacer space={2} />
    </>
  );
};

TankPortSize.propTypes = {
  dataField: PropTypes.shape({
    valueTankNumber: PropTypes.string,
    valueTankName: PropTypes.string,
    valueTankProduct: PropTypes.string,
    valueTankProductOther: PropTypes.string,
    valueTankType: PropTypes.string,
    valueTankHeight: PropTypes.string,
    valueTankLength: PropTypes.string,
    valueTankCapacity: PropTypes.string,
    valueTankMaterial: PropTypes.string,
    valueTankSensorType: PropTypes.string,
    valueTankPortSize: PropTypes.string,
    valueTankPortSizeOther: PropTypes.string,
    valueTankOptionalStand: PropTypes.string
  }).isRequired,
  setDataField: PropTypes.func.isRequired,
  error: PropTypes.string.isRequired
};

export default TankPortSize;
